// Extracted from law .babylon file
// 2 mesh(es), 2 material(s), generated 2025-12-25
// Transforms are baked into vertex positions

import type { RuneMesh, RuneMaterials } from "./types.js";

export const LAW_MATERIALS: RuneMaterials = [
  {
    name: "02___Default",
    albedoColor: [0.21570000, 0.21570000, 0.21570000],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
  {
    name: "01___Default",
    albedoColor: [0.02350000, 0.06670000, 0.39219999],
    metallic: 0.00000000,
    roughness: 0.89999998,
  },
];

const LAW_MESH_0: RuneMesh = {
  name: "Law_Rune_primitive0",
  positions: new Float32Array([
    -0.79460001, 0.43309999, -0.00000003,
    -0.83679998, 0.42829999, -0.00000003,
    -0.81849998, 0.42829999, -0.17400002,
    -0.77719998, 0.43309999, -0.16520002,
    -0.72589999, 0.43309996, -0.32320002,
    -0.64289999, 0.43309996, -0.46710002,
    -0.53170002, 0.43309996, -0.59050006,
    -0.39730000, 0.43309993, -0.68820006,
    -0.24550000, 0.43309993, -0.75570005,
    -0.08310000, 0.43309993, -0.79030007,
    0.08310000, 0.43309993, -0.79030007,
    0.24550000, 0.43309993, -0.75570005,
    0.39730000, 0.43309993, -0.68820006,
    0.53170002, 0.43309996, -0.59050006,
    0.64289999, 0.43309996, -0.46710002,
    0.72589999, 0.43309996, -0.32320002,
    0.77719998, 0.43309999, -0.16520002,
    0.79460001, 0.43309999, -0.00000003,
    0.62970001, 0.43309999, -0.03650003,
    0.62970001, 0.43309999, -0.03650003,
    0.62970001, 0.43309999, -0.03650003,
    0.43950000, 0.43309996, -0.48490003,
    0.43950000, 0.43309996, -0.48490003,
    0.39539999, 0.43309996, -0.48830003,
    0.39539999, 0.43309996, -0.48830003,
    0.03530000, 0.43309996, -0.53590006,
    0.03530000, 0.43309996, -0.53590006,
    -0.35530001, 0.43309996, -0.53250009,
    -0.35530001, 0.43309996, -0.53250009,
    -0.29420000, 0.43309996, -0.38640004,
    -0.29420000, 0.43309996, -0.38640004,
    -0.07340000, 0.43309996, -0.38980004,
    -0.07340000, 0.43309996, -0.38980004,
    -0.07340000, 0.43309996, -0.38980004,
    -0.06660000, 0.43309999, 0.11969997,
    -0.06660000, 0.43309999, 0.11969997,
    -0.06660000, 0.43309999, 0.11969997,
    -0.19570000, 0.43309999, -0.06370003,
    -0.19570000, 0.43309999, -0.06370003,
    -0.39269999, 0.43309996, -0.53250009,
    -0.39269999, 0.43309996, -0.53250009,
    -0.57609999, 0.43309999, -0.09430003,
    -0.57609999, 0.43309999, -0.09430003,
    -0.63389999, 0.43309999, 0.11289997,
    -0.63389999, 0.43309999, 0.11289997,
    -0.44369999, 0.43310001, 0.26579997,
    -0.44369999, 0.43310001, 0.26579997,
    -0.26359999, 0.43309999, 0.13669997,
    -0.26359999, 0.43309999, 0.13669997,
    -0.35530001, 0.43310001, 0.58169997,
    -0.35530001, 0.43310001, 0.58169997,
    0.30019999, 0.43310004, 0.62919992,
    0.30019999, 0.43310004, 0.62919992,
    0.30019999, 0.43310004, 0.62919992,
    0.02510000, 0.43309999, 0.15369996,
    0.02510000, 0.43309999, 0.15369996,
    0.11340000, 0.43309996, -0.34570003,
    0.11340000, 0.43309996, -0.34570003,
    0.34779999, 0.43309996, -0.33890003,
    0.34779999, 0.43309996, -0.33890003,
    0.26289999, 0.43309999, -0.06710003,
    0.26289999, 0.43309999, -0.06710003,
    0.20850000, 0.43309999, 0.15709998,
    0.20850000, 0.43309999, 0.15709998,
    0.38519999, 0.43310001, 0.30989996,
    0.38519999, 0.43310001, 0.30989996,
    0.58219999, 0.43309999, 0.16729997,
    0.58219999, 0.43309999, 0.16729997,
    0.77719998, 0.43309999, 0.16519997,
    0.72589999, 0.43310001, 0.32319996,
    0.64289999, 0.43310001, 0.46709996,
    0.53170002, 0.43310001, 0.59049994,
    0.39730000, 0.43310004, 0.68809992,
    0.24550000, 0.43310004, 0.75569993,
    0.08310000, 0.43310004, 0.79029995,
    -0.08310000, 0.43310004, 0.79029995,
    -0.24550000, 0.43310004, 0.75569993,
    -0.39730000, 0.43310004, 0.68809992,
    -0.53170002, 0.43310001, 0.59049994,
    -0.64289999, 0.43310001, 0.46709996,
    -0.72589999, 0.43310001, 0.32319996,
    -0.77719998, 0.43309999, 0.16519997,
    -0.81849998, 0.42829999, 0.17399997,
    -0.87690002, 0.41429999, -0.00000003,
    -0.85769999, 0.41429999, -0.18230003,
    -0.76450002, 0.42829996, -0.34040004,
    -0.67699999, 0.42829996, -0.49190003,
    -0.55989999, 0.42829993, -0.62190008,
    -0.41839999, 0.42829993, -0.72470003,
    -0.25860000, 0.42829993, -0.79590005,
    -0.08750000, 0.42829993, -0.83220005,
    0.08750000, 0.42829993, -0.83220005,
    0.25860000, 0.42829993, -0.79590005,
    0.41839999, 0.42829993, -0.72470003,
    0.55989999, 0.42829993, -0.62190008,
    0.67699999, 0.42829996, -0.49190003,
    0.76450002, 0.42829996, -0.34040004,
    0.81849998, 0.42829999, -0.17400002,
    0.83679998, 0.42829999, -0.00000003,
    0.81849998, 0.42829999, 0.17399997,
    0.76450002, 0.42830002, 0.34039998,
    0.67699999, 0.42830002, 0.49189997,
    0.55989999, 0.42830005, 0.62189996,
    0.41839999, 0.42830005, 0.72469991,
    0.25860000, 0.42830005, 0.79579991,
    0.08750000, 0.42830005, 0.83219993,
    -0.08750000, 0.42830005, 0.83219993,
    -0.25860000, 0.42830005, 0.79579991,
    -0.41839999, 0.42830005, 0.72469991,
    -0.55989999, 0.42830005, 0.62189996,
    -0.67699999, 0.42830002, 0.49189997,
    -0.76450002, 0.42830002, 0.34039998,
    -0.85769999, 0.41429999, 0.18229997,
    -0.91280001, 0.39170000, -0.00000003,
    -0.89289999, 0.39170000, -0.18980002,
    -0.80110002, 0.41429996, -0.35670003,
    -0.70940000, 0.41429996, -0.51540005,
    -0.58679998, 0.41429994, -0.65170008,
    -0.43840000, 0.41429994, -0.75940007,
    -0.27100000, 0.41429994, -0.83400005,
    -0.09170000, 0.41429994, -0.87210006,
    0.09170000, 0.41429994, -0.87210006,
    0.27100000, 0.41429994, -0.83400005,
    0.43840000, 0.41429994, -0.75940007,
    0.58679998, 0.41429994, -0.65170008,
    0.70940000, 0.41429996, -0.51540005,
    0.80110002, 0.41429996, -0.35670003,
    0.85769999, 0.41429999, -0.18230003,
    0.87690002, 0.41429999, -0.00000003,
    0.85769999, 0.41429999, 0.18229997,
    0.80110002, 0.41430002, 0.35669997,
    0.70940000, 0.41430002, 0.51539993,
    0.58679998, 0.41430005, 0.65169996,
    0.43840000, 0.41430005, 0.75939995,
    0.27100000, 0.41430005, 0.83399993,
    0.09170000, 0.41430005, 0.87209994,
    -0.09170000, 0.41430005, 0.87209994,
    -0.27100000, 0.41430005, 0.83399993,
    -0.43840000, 0.41430005, 0.75939995,
    -0.58679998, 0.41430005, 0.65169996,
    -0.70940000, 0.41430002, 0.51539993,
    -0.80110002, 0.41430002, 0.35669997,
    -0.89289999, 0.39170000, 0.18979996,
    -0.94290000, 0.36170000, -0.00000003,
    -0.92229998, 0.36170000, -0.19600002,
    -0.83389997, 0.39169997, -0.37130004,
    -0.73850000, 0.39169997, -0.53659999,
    -0.61080003, 0.39169994, -0.67839998,
    -0.45640001, 0.39169994, -0.79060000,
    -0.28209999, 0.39169994, -0.86820000,
    -0.09540000, 0.39169994, -0.90789998,
    0.09540000, 0.39169994, -0.90789998,
    0.28209999, 0.39169994, -0.86820000,
    0.45640001, 0.39169994, -0.79060000,
    0.61080003, 0.39169994, -0.67839998,
    0.73850000, 0.39169997, -0.53659999,
    0.83389997, 0.39169997, -0.37130004,
    0.89289999, 0.39170000, -0.18980002,
    0.91280001, 0.39170000, -0.00000003,
    0.89289999, 0.39170000, 0.18979996,
    0.83389997, 0.39170003, 0.37129998,
    0.73850000, 0.39170003, 0.53659999,
    0.61080003, 0.39170006, 0.67839998,
    0.45640001, 0.39170006, 0.79049999,
    0.28209999, 0.39170006, 0.86820000,
    0.09540000, 0.39170006, 0.90780002,
    -0.09540000, 0.39170006, 0.90780002,
    -0.28209999, 0.39170006, 0.86820000,
    -0.45640001, 0.39170006, 0.79049999,
    -0.61080003, 0.39170006, 0.67839998,
    -0.73850000, 0.39170003, 0.53659999,
    -0.83389997, 0.39170003, 0.37129998,
    -0.92229998, 0.36170000, 0.19599997,
    -0.96550000, 0.32570001, -0.00000002,
    -0.94440001, 0.32569999, -0.20070003,
    -0.86140001, 0.36169997, -0.38350004,
    -0.76279998, 0.36169997, -0.55419999,
    -0.63090003, 0.36169994, -0.70069999,
    -0.47139999, 0.36169994, -0.81660002,
    -0.29139999, 0.36169994, -0.89670002,
    -0.09860000, 0.36169994, -0.93769997,
    0.09860000, 0.36169994, -0.93769997,
    0.29139999, 0.36169994, -0.89670002,
    0.47139999, 0.36169994, -0.81660002,
    0.63090003, 0.36169994, -0.70069999,
    0.76279998, 0.36169997, -0.55419999,
    0.86140001, 0.36169997, -0.38350004,
    0.92229998, 0.36170000, -0.19600002,
    0.94290000, 0.36170000, -0.00000003,
    0.92229998, 0.36170000, 0.19599997,
    0.86140001, 0.36170003, 0.38349998,
    0.76279998, 0.36170003, 0.55419999,
    0.63090003, 0.36170006, 0.70069999,
    0.47139999, 0.36170006, 0.81660002,
    0.29139999, 0.36170006, 0.89670002,
    0.09860000, 0.36170006, 0.93769997,
    -0.09860000, 0.36170006, 0.93769997,
    -0.29139999, 0.36170006, 0.89670002,
    -0.47139999, 0.36170006, 0.81660002,
    -0.63090003, 0.36170006, 0.70069999,
    -0.76279998, 0.36170003, 0.55419999,
    -0.86140001, 0.36170003, 0.38349998,
    -0.94440001, 0.32570004, 0.20069997,
    -0.97950000, 0.28560001, -0.00000002,
    -0.95810002, 0.28559998, -0.20370002,
    -0.88200003, 0.32569999, -0.39270002,
    -0.78109998, 0.32569999, -0.56750000,
    -0.64600003, 0.32569996, -0.71749997,
    -0.48269999, 0.32569996, -0.83609998,
    -0.29830000, 0.32569996, -0.91820002,
    -0.10090000, 0.32569996, -0.96020001,
    0.10090000, 0.32569996, -0.96020001,
    0.29830000, 0.32569996, -0.91820002,
    0.48269999, 0.32569996, -0.83609998,
    0.64600003, 0.32569996, -0.71749997,
    0.78109998, 0.32569999, -0.56750000,
    0.88200003, 0.32569999, -0.39270002,
    0.94440001, 0.32569999, -0.20070003,
    0.96550000, 0.32570001, -0.00000002,
    0.94440001, 0.32570004, 0.20069997,
    0.88200003, 0.32570004, 0.39269996,
    0.78109998, 0.32570004, 0.56750000,
    0.64600003, 0.32570007, 0.71749997,
    0.48269999, 0.32570007, 0.83609998,
    0.29830000, 0.32570007, 0.91820002,
    0.10090000, 0.32570007, 0.96020001,
    -0.10090000, 0.32570007, 0.96020001,
    -0.29830000, 0.32570007, 0.91820002,
    -0.48269999, 0.32570007, 0.83609998,
    -0.64600003, 0.32570007, 0.71749997,
    -0.78109998, 0.32570004, 0.56750000,
    -0.88200003, 0.32570004, 0.39269996,
    -0.95810002, 0.28560004, 0.20359999,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.98430002, 0.24339999, -0.00000002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.96270001, 0.24339998, -0.20460002,
    -0.89480001, 0.28559998, -0.39840004,
    -0.79240000, 0.28559998, -0.57569999,
    -0.65539998, 0.28559995, -0.72790003,
    -0.48969999, 0.28559995, -0.84829998,
    -0.30270001, 0.28559995, -0.93159997,
    -0.10240000, 0.28559995, -0.97409999,
    0.10240000, 0.28559995, -0.97409999,
    0.30270001, 0.28559995, -0.93159997,
    0.48969999, 0.28559995, -0.84829998,
    0.65539998, 0.28559995, -0.72790003,
    0.79240000, 0.28559998, -0.57569999,
    0.89480001, 0.28559998, -0.39840004,
    0.95810002, 0.28559998, -0.20370002,
    0.97950000, 0.28560001, -0.00000002,
    0.95810002, 0.28560004, 0.20359999,
    0.89480001, 0.28560004, 0.39839998,
    0.79240000, 0.28560004, 0.57569999,
    0.65539998, 0.28560007, 0.72790003,
    0.48969999, 0.28560007, 0.84829998,
    0.30270001, 0.28560007, 0.93159997,
    0.10240000, 0.28560007, 0.97409999,
    -0.10240000, 0.28560007, 0.97409999,
    -0.30270001, 0.28560007, 0.93159997,
    -0.48980001, 0.28560007, 0.84829998,
    -0.65539998, 0.28560007, 0.72790003,
    -0.79240000, 0.28560004, 0.57569999,
    -0.89480001, 0.28560004, 0.39839998,
    -0.96270001, 0.24340001, 0.20459999,
    -0.96270001, 0.24340001, 0.20459999,
    -0.98430002, 0.21650000, -0.00000002,
    -0.98430002, 0.21650000, -0.00000002,
    -0.96270001, 0.21649998, -0.20460002,
    -0.89920002, 0.24339996, -0.40030003,
    -0.89920002, 0.24339996, -0.40030003,
    -0.79629999, 0.24339995, -0.57849997,
    -0.79629999, 0.24339995, -0.57849997,
    -0.65859997, 0.24339993, -0.73140001,
    -0.65859997, 0.24339993, -0.73140001,
    -0.49210000, 0.24339993, -0.85240000,
    -0.49210000, 0.24339993, -0.85240000,
    -0.30419999, 0.24339992, -0.93610001,
    -0.30419999, 0.24339992, -0.93610001,
    -0.10290000, 0.24339992, -0.97890002,
    -0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.10290000, 0.24339992, -0.97890002,
    0.30419999, 0.24339992, -0.93610001,
    0.30419999, 0.24339992, -0.93610001,
    0.49210000, 0.24339993, -0.85240000,
    0.49210000, 0.24339993, -0.85240000,
    0.65859997, 0.24339993, -0.73140001,
    0.65859997, 0.24339993, -0.73140001,
    0.79629999, 0.24339995, -0.57849997,
    0.79629999, 0.24339995, -0.57849997,
    0.89920002, 0.24339996, -0.40030003,
    0.89920002, 0.24339996, -0.40030003,
    0.96270001, 0.24339998, -0.20460002,
    0.96270001, 0.24339998, -0.20460002,
    0.98430002, 0.24339999, -0.00000002,
    0.98430002, 0.24339999, -0.00000002,
    0.96270001, 0.24340001, 0.20459999,
    0.96270001, 0.24340001, 0.20459999,
    0.89920002, 0.24340002, 0.40029997,
    0.89920002, 0.24340002, 0.40029997,
    0.79629999, 0.24340004, 0.57849997,
    0.79629999, 0.24340004, 0.57849997,
    0.65859997, 0.24340005, 0.73140001,
    0.65859997, 0.24340005, 0.73140001,
    0.49210000, 0.24340005, 0.85240000,
    0.49210000, 0.24340005, 0.85240000,
    0.30410001, 0.24340007, 0.93610001,
    0.30410001, 0.24340007, 0.93610001,
    0.10290000, 0.24340007, 0.97890002,
    0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.10290000, 0.24340007, 0.97890002,
    -0.30419999, 0.24340007, 0.93610001,
    -0.30419999, 0.24340007, 0.93610001,
    -0.49210000, 0.24340005, 0.85240000,
    -0.49210000, 0.24340005, 0.85240000,
    -0.65859997, 0.24340005, 0.73140001,
    -0.65859997, 0.24340005, 0.73140001,
    -0.79629999, 0.24340004, 0.57849997,
    -0.79629999, 0.24340004, 0.57849997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.89920002, 0.24340002, 0.40029997,
    -0.96270001, 0.21650001, 0.20459999,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.98430002, 0.18960001, -0.00000001,
    -0.96270001, 0.18959999, -0.20460002,
    -0.96270001, 0.18959999, -0.20460002,
    -0.89920002, 0.21649997, -0.40030003,
    -0.79629999, 0.21649995, -0.57849997,
    -0.65859997, 0.21649994, -0.73140001,
    -0.49210000, 0.21649994, -0.85240000,
    -0.30419999, 0.21649992, -0.93610001,
    -0.10290000, 0.21649992, -0.97890002,
    0.10290000, 0.21649992, -0.97890002,
    0.30419999, 0.21649992, -0.93610001,
    0.49210000, 0.21649994, -0.85240000,
    0.65859997, 0.21649994, -0.73140001,
    0.79629999, 0.21649995, -0.57849997,
    0.89920002, 0.21649997, -0.40030003,
    0.96270001, 0.21649998, -0.20460002,
    0.98430002, 0.21650000, -0.00000002,
    0.96270001, 0.21650001, 0.20459999,
    0.89920002, 0.21650003, 0.40029997,
    0.79629999, 0.21650004, 0.57849997,
    0.65859997, 0.21650006, 0.73140001,
    0.49210000, 0.21650006, 0.85240000,
    0.30410001, 0.21650007, 0.93610001,
    0.10290000, 0.21650007, 0.97890002,
    -0.10290000, 0.21650007, 0.97890002,
    -0.30419999, 0.21650007, 0.93610001,
    -0.49210000, 0.21650006, 0.85240000,
    -0.65859997, 0.21650006, 0.73140001,
    -0.79629999, 0.21650004, 0.57849997,
    -0.89920002, 0.21650003, 0.40029997,
    -0.96270001, 0.18960002, 0.20459999,
    -0.96270001, 0.18960002, 0.20459999,
    -0.97950000, 0.14740001, -0.00000001,
    -0.95810002, 0.14739999, -0.20370002,
    -0.89920002, 0.18959998, -0.40030000,
    -0.89920002, 0.18959998, -0.40030000,
    -0.79629999, 0.18959996, -0.57849997,
    -0.79629999, 0.18959996, -0.57849997,
    -0.65859997, 0.18959995, -0.73140001,
    -0.65859997, 0.18959995, -0.73140001,
    -0.49210000, 0.18959995, -0.85240000,
    -0.49210000, 0.18959995, -0.85240000,
    -0.30419999, 0.18959993, -0.93610001,
    -0.30419999, 0.18959993, -0.93610001,
    -0.10290000, 0.18959993, -0.97890002,
    -0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.10290000, 0.18959993, -0.97890002,
    0.30419999, 0.18959993, -0.93610001,
    0.30419999, 0.18959993, -0.93610001,
    0.49210000, 0.18959995, -0.85240000,
    0.49210000, 0.18959995, -0.85240000,
    0.65859997, 0.18959995, -0.73140001,
    0.65859997, 0.18959995, -0.73140001,
    0.79629999, 0.18959996, -0.57849997,
    0.79629999, 0.18959996, -0.57849997,
    0.89920002, 0.18959998, -0.40030000,
    0.89920002, 0.18959998, -0.40030000,
    0.96270001, 0.18959999, -0.20460002,
    0.96270001, 0.18959999, -0.20460002,
    0.98430002, 0.18960001, -0.00000001,
    0.98430002, 0.18960001, -0.00000001,
    0.96270001, 0.18960002, 0.20459999,
    0.96270001, 0.18960002, 0.20459999,
    0.89920002, 0.18960004, 0.40030000,
    0.89920002, 0.18960004, 0.40030000,
    0.79629999, 0.18960005, 0.57849997,
    0.79629999, 0.18960005, 0.57849997,
    0.65859997, 0.18960007, 0.73140001,
    0.65859997, 0.18960007, 0.73140001,
    0.49210000, 0.18960007, 0.85240000,
    0.49210000, 0.18960007, 0.85240000,
    0.30410001, 0.18960008, 0.93610001,
    0.30410001, 0.18960008, 0.93610001,
    0.10290000, 0.18960008, 0.97890002,
    0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.10290000, 0.18960008, 0.97890002,
    -0.30419999, 0.18960008, 0.93610001,
    -0.30419999, 0.18960008, 0.93610001,
    -0.49210000, 0.18960007, 0.85240000,
    -0.49210000, 0.18960007, 0.85240000,
    -0.65859997, 0.18960007, 0.73140001,
    -0.65859997, 0.18960007, 0.73140001,
    -0.79629999, 0.18960005, 0.57849997,
    -0.79629999, 0.18960005, 0.57849997,
    -0.89920002, 0.18960004, 0.40030000,
    -0.89920002, 0.18960004, 0.40030000,
    -0.95810002, 0.14740002, 0.20359999,
    -0.96550000, 0.10740000, -0.00000001,
    -0.94440001, 0.10739999, -0.20070001,
    -0.89480001, 0.14739998, -0.39840001,
    -0.79240000, 0.14739996, -0.57569999,
    -0.65539998, 0.14739995, -0.72790003,
    -0.48969999, 0.14739995, -0.84829998,
    -0.30270001, 0.14739993, -0.93159997,
    -0.10240000, 0.14739993, -0.97409999,
    0.10240000, 0.14739993, -0.97409999,
    0.30270001, 0.14739993, -0.93159997,
    0.48969999, 0.14739995, -0.84829998,
    0.65539998, 0.14739995, -0.72790003,
    0.79240000, 0.14739996, -0.57569999,
    0.89480001, 0.14739998, -0.39840001,
    0.95810002, 0.14739999, -0.20370002,
    0.97950000, 0.14740001, -0.00000001,
    0.95810002, 0.14740002, 0.20359999,
    0.89480001, 0.14740004, 0.39840001,
    0.79240000, 0.14740005, 0.57569999,
    0.65539998, 0.14740007, 0.72790003,
    0.48969999, 0.14740007, 0.84829998,
    0.30270001, 0.14740008, 0.93159997,
    0.10240000, 0.14740008, 0.97409999,
    -0.10240000, 0.14740008, 0.97409999,
    -0.30270001, 0.14740008, 0.93159997,
    -0.48980001, 0.14740007, 0.84829998,
    -0.65539998, 0.14740007, 0.72790003,
    -0.79240000, 0.14740005, 0.57569999,
    -0.89480001, 0.14740004, 0.39840001,
    -0.94440001, 0.10740001, 0.20069999,
    -0.94290000, 0.07140000, -0.00000001,
    -0.92229998, 0.07139999, -0.19599999,
    -0.88200003, 0.10739997, -0.39269999,
    -0.78109998, 0.10739996, -0.56750000,
    -0.64600003, 0.10739995, -0.71749997,
    -0.48269999, 0.10739994, -0.83609998,
    -0.29830000, 0.10739993, -0.91820002,
    -0.10090000, 0.10739993, -0.96020001,
    0.10090000, 0.10739993, -0.96020001,
    0.29830000, 0.10739993, -0.91820002,
    0.48269999, 0.10739994, -0.83609998,
    0.64600003, 0.10739995, -0.71749997,
    0.78109998, 0.10739996, -0.56750000,
    0.88200003, 0.10739997, -0.39269999,
    0.94440001, 0.10739999, -0.20070001,
    0.96550000, 0.10740000, -0.00000001,
    0.94440001, 0.10740001, 0.20069999,
    0.88200003, 0.10740003, 0.39269999,
    0.78109998, 0.10740004, 0.56750000,
    0.64600003, 0.10740005, 0.71749997,
    0.48269999, 0.10740006, 0.83609998,
    0.29830000, 0.10740007, 0.91820002,
    0.10090000, 0.10740007, 0.96020001,
    -0.10090000, 0.10740007, 0.96020001,
    -0.29830000, 0.10740007, 0.91820002,
    -0.48269999, 0.10740006, 0.83609998,
    -0.64600003, 0.10740005, 0.71749997,
    -0.78109998, 0.10740004, 0.56750000,
    -0.88200003, 0.10740003, 0.39269999,
    -0.92229998, 0.07140002, 0.19599999,
    -0.91280001, 0.04140000, -0.00000000,
    -0.89289999, 0.04139999, -0.18979999,
    -0.86140001, 0.07139997, -0.38350001,
    -0.76279998, 0.07139996, -0.55419999,
    -0.63090003, 0.07139995, -0.70069999,
    -0.47139999, 0.07139994, -0.81660002,
    -0.29139999, 0.07139993, -0.89670002,
    -0.09860000, 0.07139993, -0.93769997,
    0.09860000, 0.07139993, -0.93769997,
    0.29139999, 0.07139993, -0.89670002,
    0.47139999, 0.07139994, -0.81660002,
    0.63090003, 0.07139995, -0.70069999,
    0.76279998, 0.07139996, -0.55419999,
    0.86140001, 0.07139997, -0.38350001,
    0.92229998, 0.07139999, -0.19599999,
    0.94290000, 0.07140000, -0.00000001,
    0.92229998, 0.07140002, 0.19599999,
    0.86140001, 0.07140003, 0.38350001,
    0.76279998, 0.07140005, 0.55419999,
    0.63090003, 0.07140005, 0.70069999,
    0.47139999, 0.07140006, 0.81660002,
    0.29139999, 0.07140007, 0.89670002,
    0.09860000, 0.07140008, 0.93769997,
    -0.09860000, 0.07140008, 0.93769997,
    -0.29139999, 0.07140007, 0.89670002,
    -0.47139999, 0.07140006, 0.81660002,
    -0.63090003, 0.07140005, 0.70069999,
    -0.76279998, 0.07140005, 0.55419999,
    -0.86140001, 0.07140003, 0.38350001,
    -0.89289999, 0.04140002, 0.18979999,
    -0.87690002, 0.01880000, -0.00000000,
    -0.85769999, 0.01879999, -0.18230000,
    -0.83389997, 0.04139997, -0.37130001,
    -0.73850000, 0.04139996, -0.53659999,
    -0.61080003, 0.04139995, -0.67839998,
    -0.45640001, 0.04139994, -0.79060000,
    -0.28209999, 0.04139993, -0.86820000,
    -0.09540000, 0.04139993, -0.90789998,
    0.09540000, 0.04139993, -0.90789998,
    0.28209999, 0.04139993, -0.86820000,
    0.45640001, 0.04139994, -0.79060000,
    0.61080003, 0.04139995, -0.67839998,
    0.73850000, 0.04139996, -0.53659999,
    0.83389997, 0.04139997, -0.37130001,
    0.89289999, 0.04139999, -0.18979999,
    0.91280001, 0.04140000, -0.00000000,
    0.89289999, 0.04140002, 0.18979999,
    0.83389997, 0.04140003, 0.37130001,
    0.73850000, 0.04140004, 0.53659999,
    0.61080003, 0.04140005, 0.67839998,
    0.45640001, 0.04140006, 0.79049999,
    0.28209999, 0.04140007, 0.86820000,
    0.09540000, 0.04140007, 0.90780002,
    -0.09540000, 0.04140007, 0.90780002,
    -0.28209999, 0.04140007, 0.86820000,
    -0.45640001, 0.04140006, 0.79049999,
    -0.61080003, 0.04140005, 0.67839998,
    -0.73850000, 0.04140004, 0.53659999,
    -0.83389997, 0.04140003, 0.37130001,
    -0.85769999, 0.01880001, 0.18230000,
    -0.83679998, 0.00480000, -0.00000000,
    -0.81849998, 0.00479999, -0.17399999,
    -0.80110002, 0.01879997, -0.35670000,
    -0.70940000, 0.01879996, -0.51539999,
    -0.58679998, 0.01879995, -0.65170002,
    -0.43840000, 0.01879994, -0.75940001,
    -0.27100000, 0.01879994, -0.83399999,
    -0.09170000, 0.01879993, -0.87210000,
    0.09170000, 0.01879993, -0.87210000,
    0.27100000, 0.01879994, -0.83399999,
    0.43840000, 0.01879994, -0.75940001,
    0.58679998, 0.01879995, -0.65170002,
    0.70940000, 0.01879996, -0.51539999,
    0.80110002, 0.01879997, -0.35670000,
    0.85769999, 0.01879999, -0.18230000,
    0.87690002, 0.01880000, -0.00000000,
    0.85769999, 0.01880001, 0.18230000,
    0.80110002, 0.01880003, 0.35670000,
    0.70940000, 0.01880004, 0.51539999,
    0.58679998, 0.01880005, 0.65170002,
    0.43840000, 0.01880006, 0.75940001,
    0.27100000, 0.01880006, 0.83399999,
    0.09170000, 0.01880006, 0.87210000,
    -0.09170000, 0.01880006, 0.87210000,
    -0.27100000, 0.01880006, 0.83399999,
    -0.43840000, 0.01880006, 0.75940001,
    -0.58679998, 0.01880005, 0.65170002,
    -0.70940000, 0.01880004, 0.51539999,
    -0.80110002, 0.01880003, 0.35670000,
    -0.81849998, 0.00480001, 0.17399999,
    -0.79460001, 0.00000000, 0.00000000,
    -0.77719998, -0.00000001, -0.16520000,
    -0.76450002, 0.00479997, -0.34040001,
    -0.67699999, 0.00479996, -0.49190000,
    -0.55989999, 0.00479995, -0.62190002,
    -0.41839999, 0.00479995, -0.72469997,
    -0.25860000, 0.00479994, -0.79589999,
    -0.08750000, 0.00479994, -0.83219999,
    0.08750000, 0.00479994, -0.83219999,
    0.25860000, 0.00479994, -0.79589999,
    0.41839999, 0.00479995, -0.72469997,
    0.55989999, 0.00479995, -0.62190002,
    0.67699999, 0.00479996, -0.49190000,
    0.76450002, 0.00479997, -0.34040001,
    0.81849998, 0.00479999, -0.17399999,
    0.83679998, 0.00480000, -0.00000000,
    0.81849998, 0.00480001, 0.17399999,
    0.76450002, 0.00480003, 0.34040001,
    0.67699999, 0.00480004, 0.49190000,
    0.55989999, 0.00480005, 0.62190002,
    0.41839999, 0.00480005, 0.72469997,
    0.25860000, 0.00480006, 0.79579997,
    0.08750000, 0.00480006, 0.83219999,
    -0.08750000, 0.00480006, 0.83219999,
    -0.25860000, 0.00480006, 0.79579997,
    -0.41839999, 0.00480005, 0.72469997,
    -0.55989999, 0.00480005, 0.62190002,
    -0.67699999, 0.00480004, 0.49190000,
    -0.76450002, 0.00480003, 0.34040001,
    -0.77719998, 0.00000001, 0.16520000,
    0.00000000, 0.00000000, 0.00000000,
    -0.72589999, -0.00000002, -0.32319999,
    -0.64289999, -0.00000004, -0.46709999,
    -0.53170002, -0.00000004, -0.59050000,
    -0.39730000, -0.00000005, -0.68820000,
    -0.24550000, -0.00000006, -0.75569999,
    -0.08310000, -0.00000006, -0.79030001,
    0.08310000, -0.00000006, -0.79030001,
    0.24550000, -0.00000006, -0.75569999,
    0.39730000, -0.00000005, -0.68820000,
    0.53170002, -0.00000004, -0.59050000,
    0.64289999, -0.00000004, -0.46709999,
    0.72589999, -0.00000002, -0.32319999,
    0.77719998, -0.00000001, -0.16520000,
    0.79460001, 0.00000000, 0.00000000,
    0.77719998, 0.00000001, 0.16520000,
    0.72589999, 0.00000002, 0.32319999,
    0.64289999, 0.00000004, 0.46709999,
    0.53170002, 0.00000004, 0.59050000,
    0.39730000, 0.00000005, 0.68809998,
    0.24550000, 0.00000006, 0.75569999,
    0.08310000, 0.00000006, 0.79030001,
    -0.08310000, 0.00000006, 0.79030001,
    -0.24550000, 0.00000006, 0.75569999,
    -0.39730000, 0.00000005, 0.68809998,
    -0.53170002, 0.00000004, 0.59050000,
    -0.64289999, 0.00000004, 0.46709999,
    -0.72589999, 0.00000002, 0.32319999,
    0.30019999, 0.34580007, 0.62919998,
    0.02510000, 0.34580001, 0.15369996,
    0.11340000, 0.34579998, -0.34570003,
    -0.35530001, 0.34580004, 0.58170003,
    -0.06660000, 0.34580001, 0.11969997,
    -0.07340000, 0.34579998, -0.38980004,
    -0.07340000, 0.34579998, -0.38980004,
    -0.29420000, 0.34579998, -0.38640004,
    -0.35530001, 0.34579998, -0.53250003,
    0.03530000, 0.34579998, -0.53590000,
    0.39539999, 0.34579998, -0.48830003,
    0.39539999, 0.34579998, -0.48830003,
    0.34779999, 0.34579998, -0.33890003,
    -0.57609999, 0.34580001, -0.09430003,
    -0.63389999, 0.34580001, 0.11289997,
    -0.44369999, 0.34580004, 0.26579997,
    -0.39269999, 0.34579998, -0.53250003,
    -0.19570000, 0.34580001, -0.06370003,
    -0.30779999, 0.34580001, -0.07050003,
    -0.39269999, 0.34579998, -0.42380002,
    -0.48440000, 0.34580001, -0.07050003,
    -0.48440000, 0.34580001, -0.07050003,
    -0.26359999, 0.34580001, 0.13669997,
    -0.48440000, 0.43309999, -0.07050003,
    -0.48440000, 0.43309999, -0.07050003,
    -0.48440000, 0.43309999, -0.07050003,
    -0.30779999, 0.43309999, -0.07050003,
    -0.30779999, 0.43309999, -0.07050003,
    -0.30779999, 0.43309999, -0.07050003,
    -0.39269999, 0.43309996, -0.42380002,
    -0.39269999, 0.43309996, -0.42380002,
    0.26289999, 0.34580001, -0.06710003,
    0.20850000, 0.34580001, 0.15709998,
    0.38519999, 0.34580004, 0.30989996,
    0.43950000, 0.34579998, -0.48490003,
    0.62970001, 0.34580001, -0.03650003,
    0.62970001, 0.34580001, -0.03650003,
    0.58219999, 0.34580001, 0.16729997,
    0.52440000, 0.34580001, -0.01620003,
    0.52440000, 0.34580001, -0.01620003,
    0.44290000, 0.34579998, -0.35920003,
    0.34439999, 0.34580001, -0.01960003,
    0.34439999, 0.43309999, -0.01960003,
    0.34439999, 0.43309999, -0.01960003,
    0.52440000, 0.43309999, -0.01620003,
    0.52440000, 0.43309999, -0.01620003,
    0.52440000, 0.43309999, -0.01620003,
    0.44290000, 0.43309996, -0.35920003,
    0.44290000, 0.43309996, -0.35920003,
  ]),
  indices: new Uint16Array([
    0, 1, 2, 0, 2, 3, 653, 651, 648, 81, 82, 1,
    81, 1, 0, 1, 83, 84, 1, 84, 2, 3, 2, 85,
    3, 85, 4, 4, 85, 86, 4, 86, 5, 5, 86, 87,
    5, 87, 6, 6, 87, 88, 6, 88, 7, 7, 88, 89,
    7, 89, 8, 8, 89, 90, 8, 90, 9, 9, 90, 91,
    9, 91, 10, 10, 91, 92, 10, 92, 11, 11, 92, 93,
    11, 93, 12, 12, 93, 94, 12, 94, 13, 13, 94, 95,
    13, 95, 14, 14, 95, 96, 14, 96, 15, 15, 96, 97,
    15, 97, 16, 16, 97, 98, 16, 98, 17, 17, 98, 99,
    17, 99, 68, 68, 99, 100, 68, 100, 69, 69, 100, 101,
    69, 101, 70, 70, 101, 102, 70, 102, 71, 71, 102, 103,
    71, 103, 72, 72, 103, 104, 72, 104, 73, 73, 104, 105,
    73, 105, 74, 74, 105, 106, 74, 106, 75, 75, 106, 107,
    75, 107, 76, 76, 107, 108, 76, 108, 77, 77, 108, 109,
    77, 109, 78, 78, 109, 110, 78, 110, 79, 79, 110, 111,
    79, 111, 80, 80, 111, 82, 80, 82, 81, 82, 112, 83,
    82, 83, 1, 83, 113, 114, 83, 114, 84, 2, 84, 115,
    2, 115, 85, 85, 115, 116, 85, 116, 86, 86, 116, 117,
    86, 117, 87, 87, 117, 118, 87, 118, 88, 88, 118, 119,
    88, 119, 89, 89, 119, 120, 89, 120, 90, 90, 120, 121,
    90, 121, 91, 91, 121, 122, 91, 122, 92, 92, 122, 123,
    92, 123, 93, 93, 123, 124, 93, 124, 94, 94, 124, 125,
    94, 125, 95, 95, 125, 126, 95, 126, 96, 96, 126, 127,
    96, 127, 97, 97, 127, 128, 97, 128, 98, 98, 128, 129,
    98, 129, 99, 99, 129, 130, 99, 130, 100, 100, 130, 131,
    100, 131, 101, 101, 131, 132, 101, 132, 102, 102, 132, 133,
    102, 133, 103, 103, 133, 134, 103, 134, 104, 104, 134, 135,
    104, 135, 105, 105, 135, 136, 105, 136, 106, 106, 136, 137,
    106, 137, 107, 107, 137, 138, 107, 138, 108, 108, 138, 139,
    108, 139, 109, 109, 139, 140, 109, 140, 110, 110, 140, 141,
    110, 141, 111, 111, 141, 112, 111, 112, 82, 112, 142, 113,
    112, 113, 83, 113, 143, 144, 113, 144, 114, 84, 114, 145,
    84, 145, 115, 115, 145, 146, 115, 146, 116, 116, 146, 147,
    116, 147, 117, 117, 147, 148, 117, 148, 118, 118, 148, 149,
    118, 149, 119, 119, 149, 150, 119, 150, 120, 120, 150, 151,
    120, 151, 121, 121, 151, 152, 121, 152, 122, 122, 152, 153,
    122, 153, 123, 123, 153, 154, 123, 154, 124, 124, 154, 155,
    124, 155, 125, 125, 155, 156, 125, 156, 126, 126, 156, 157,
    126, 157, 127, 127, 157, 158, 127, 158, 128, 128, 158, 159,
    128, 159, 129, 129, 159, 160, 129, 160, 130, 130, 160, 161,
    130, 161, 131, 131, 161, 162, 131, 162, 132, 132, 162, 163,
    132, 163, 133, 133, 163, 164, 133, 164, 134, 134, 164, 165,
    134, 165, 135, 135, 165, 166, 135, 166, 136, 136, 166, 167,
    136, 167, 137, 137, 167, 168, 137, 168, 138, 138, 168, 169,
    138, 169, 139, 139, 169, 170, 139, 170, 140, 140, 170, 171,
    140, 171, 141, 141, 171, 142, 141, 142, 112, 142, 172, 143,
    142, 143, 113, 143, 173, 174, 143, 174, 144, 114, 144, 175,
    114, 175, 145, 145, 175, 176, 145, 176, 146, 146, 176, 177,
    146, 177, 147, 147, 177, 178, 147, 178, 148, 148, 178, 179,
    148, 179, 149, 149, 179, 180, 149, 180, 150, 150, 180, 181,
    150, 181, 151, 151, 181, 182, 151, 182, 152, 152, 182, 183,
    152, 183, 153, 153, 183, 184, 153, 184, 154, 154, 184, 185,
    154, 185, 155, 155, 185, 186, 155, 186, 156, 156, 186, 187,
    156, 187, 157, 157, 187, 188, 157, 188, 158, 158, 188, 189,
    158, 189, 159, 159, 189, 190, 159, 190, 160, 160, 190, 191,
    160, 191, 161, 161, 191, 192, 161, 192, 162, 162, 192, 193,
    162, 193, 163, 163, 193, 194, 163, 194, 164, 164, 194, 195,
    164, 195, 165, 165, 195, 196, 165, 196, 166, 166, 196, 197,
    166, 197, 167, 167, 197, 198, 167, 198, 168, 168, 198, 199,
    168, 199, 169, 169, 199, 200, 169, 200, 170, 170, 200, 201,
    170, 201, 171, 171, 201, 172, 171, 172, 142, 172, 202, 173,
    172, 173, 143, 173, 203, 204, 173, 204, 174, 144, 174, 205,
    144, 205, 175, 175, 205, 206, 175, 206, 176, 176, 206, 207,
    176, 207, 177, 177, 207, 208, 177, 208, 178, 178, 208, 209,
    178, 209, 179, 179, 209, 210, 179, 210, 180, 180, 210, 211,
    180, 211, 181, 181, 211, 212, 181, 212, 182, 182, 212, 213,
    182, 213, 183, 183, 213, 214, 183, 214, 184, 184, 214, 215,
    184, 215, 185, 185, 215, 216, 185, 216, 186, 186, 216, 217,
    186, 217, 187, 187, 217, 218, 187, 218, 188, 188, 218, 219,
    188, 219, 189, 189, 219, 220, 189, 220, 190, 190, 220, 221,
    190, 221, 191, 191, 221, 222, 191, 222, 192, 192, 222, 223,
    192, 223, 193, 193, 223, 224, 193, 224, 194, 194, 224, 225,
    194, 225, 195, 195, 225, 226, 195, 226, 196, 196, 226, 227,
    196, 227, 197, 197, 227, 228, 197, 228, 198, 198, 228, 229,
    198, 229, 199, 199, 229, 230, 199, 230, 200, 200, 230, 231,
    200, 231, 201, 201, 231, 202, 201, 202, 172, 202, 232, 203,
    202, 203, 173, 203, 235, 237, 203, 237, 204, 174, 204, 238,
    174, 238, 205, 205, 238, 239, 205, 239, 206, 206, 239, 240,
    206, 240, 207, 207, 240, 241, 207, 241, 208, 208, 241, 242,
    208, 242, 209, 209, 242, 243, 209, 243, 210, 210, 243, 244,
    210, 244, 211, 211, 244, 245, 211, 245, 212, 212, 245, 246,
    212, 246, 213, 213, 246, 247, 213, 247, 214, 214, 247, 248,
    214, 248, 215, 215, 248, 249, 215, 249, 216, 216, 249, 250,
    216, 250, 217, 217, 250, 251, 217, 251, 218, 218, 251, 252,
    218, 252, 219, 219, 252, 253, 219, 253, 220, 220, 253, 254,
    220, 254, 221, 221, 254, 255, 221, 255, 222, 222, 255, 256,
    222, 256, 223, 223, 256, 257, 223, 257, 224, 224, 257, 258,
    224, 258, 225, 225, 258, 259, 225, 259, 226, 226, 259, 260,
    226, 260, 227, 227, 260, 261, 227, 261, 228, 228, 261, 262,
    228, 262, 229, 229, 262, 263, 229, 263, 230, 230, 263, 264,
    230, 264, 231, 231, 264, 232, 231, 232, 202, 232, 266, 235,
    232, 235, 203, 233, 267, 269, 233, 269, 236, 204, 237, 271,
    204, 271, 238, 238, 271, 273, 238, 273, 239, 239, 273, 275,
    239, 275, 240, 240, 275, 277, 240, 277, 241, 241, 277, 279,
    241, 279, 242, 242, 279, 281, 242, 281, 243, 243, 281, 283,
    243, 283, 244, 244, 283, 285, 244, 285, 245, 245, 285, 286,
    245, 286, 246, 246, 286, 288, 246, 288, 247, 247, 288, 290,
    247, 290, 248, 248, 290, 292, 248, 292, 249, 249, 292, 294,
    249, 294, 250, 250, 294, 296, 250, 296, 251, 251, 296, 298,
    251, 298, 252, 252, 298, 300, 252, 300, 253, 253, 300, 302,
    253, 302, 254, 254, 302, 304, 254, 304, 255, 255, 304, 306,
    255, 306, 256, 256, 306, 308, 256, 308, 257, 257, 308, 310,
    257, 310, 258, 258, 310, 312, 258, 312, 259, 259, 312, 314,
    259, 314, 260, 260, 314, 316, 260, 316, 261, 261, 316, 318,
    261, 318, 262, 262, 318, 321, 262, 321, 263, 263, 321, 323,
    263, 323, 264, 264, 323, 266, 264, 266, 232, 265, 324, 268,
    265, 268, 234, 267, 325, 328, 267, 328, 269, 236, 269, 330,
    236, 330, 270, 270, 330, 331, 270, 331, 272, 272, 331, 332,
    272, 332, 274, 274, 332, 333, 274, 333, 276, 276, 333, 334,
    276, 334, 278, 278, 334, 335, 278, 335, 280, 280, 335, 336,
    280, 336, 282, 282, 336, 337, 282, 337, 284, 284, 337, 338,
    284, 338, 287, 287, 338, 339, 287, 339, 289, 289, 339, 340,
    289, 340, 291, 291, 340, 341, 291, 341, 293, 293, 341, 342,
    293, 342, 295, 295, 342, 343, 295, 343, 297, 297, 343, 344,
    297, 344, 299, 299, 344, 345, 299, 345, 301, 301, 345, 346,
    301, 346, 303, 303, 346, 347, 303, 347, 305, 305, 347, 348,
    305, 348, 307, 307, 348, 349, 307, 349, 309, 309, 349, 350,
    309, 350, 311, 311, 350, 351, 311, 351, 313, 313, 351, 352,
    313, 352, 315, 315, 352, 353, 315, 353, 317, 317, 353, 354,
    317, 354, 319, 319, 354, 355, 319, 355, 320, 320, 355, 356,
    320, 356, 322, 322, 356, 324, 322, 324, 265, 324, 357, 327,
    324, 327, 268, 326, 359, 360, 326, 360, 329, 269, 328, 361,
    269, 361, 330, 330, 361, 363, 330, 363, 331, 331, 363, 365,
    331, 365, 332, 332, 365, 367, 332, 367, 333, 333, 367, 369,
    333, 369, 334, 334, 369, 371, 334, 371, 335, 335, 371, 373,
    335, 373, 336, 336, 373, 375, 336, 375, 337, 337, 375, 378,
    337, 378, 338, 338, 378, 380, 338, 380, 339, 339, 380, 382,
    339, 382, 340, 340, 382, 384, 340, 384, 341, 341, 384, 386,
    341, 386, 342, 342, 386, 388, 342, 388, 343, 343, 388, 390,
    343, 390, 344, 344, 390, 392, 344, 392, 345, 345, 392, 394,
    345, 394, 346, 346, 394, 396, 346, 396, 347, 347, 396, 398,
    347, 398, 348, 348, 398, 400, 348, 400, 349, 349, 400, 402,
    349, 402, 350, 350, 402, 404, 350, 404, 351, 351, 404, 406,
    351, 406, 352, 352, 406, 408, 352, 408, 353, 353, 408, 410,
    353, 410, 354, 354, 410, 411, 354, 411, 355, 355, 411, 413,
    355, 413, 356, 356, 413, 357, 356, 357, 324, 358, 415, 359,
    358, 359, 326, 359, 416, 417, 359, 417, 360, 329, 360, 418,
    329, 418, 362, 362, 418, 419, 362, 419, 364, 364, 419, 420,
    364, 420, 366, 366, 420, 421, 366, 421, 368, 368, 421, 422,
    368, 422, 370, 370, 422, 423, 370, 423, 372, 372, 423, 424,
    372, 424, 374, 374, 424, 425, 374, 425, 376, 376, 425, 426,
    376, 426, 377, 377, 426, 427, 377, 427, 379, 379, 427, 428,
    379, 428, 381, 381, 428, 429, 381, 429, 383, 383, 429, 430,
    383, 430, 385, 385, 430, 431, 385, 431, 387, 387, 431, 432,
    387, 432, 389, 389, 432, 433, 389, 433, 391, 391, 433, 434,
    391, 434, 393, 393, 434, 435, 393, 435, 395, 395, 435, 436,
    395, 436, 397, 397, 436, 437, 397, 437, 399, 399, 437, 438,
    399, 438, 401, 401, 438, 439, 401, 439, 403, 403, 439, 440,
    403, 440, 405, 405, 440, 441, 405, 441, 407, 407, 441, 442,
    407, 442, 409, 409, 442, 443, 409, 443, 412, 412, 443, 444,
    412, 444, 414, 414, 444, 415, 414, 415, 358, 415, 445, 416,
    415, 416, 359, 416, 446, 447, 416, 447, 417, 360, 417, 448,
    360, 448, 418, 418, 448, 449, 418, 449, 419, 419, 449, 450,
    419, 450, 420, 420, 450, 451, 420, 451, 421, 421, 451, 452,
    421, 452, 422, 422, 452, 453, 422, 453, 423, 423, 453, 454,
    423, 454, 424, 424, 454, 455, 424, 455, 425, 425, 455, 456,
    425, 456, 426, 426, 456, 457, 426, 457, 427, 427, 457, 458,
    427, 458, 428, 428, 458, 459, 428, 459, 429, 429, 459, 460,
    429, 460, 430, 430, 460, 461, 430, 461, 431, 431, 461, 462,
    431, 462, 432, 432, 462, 463, 432, 463, 433, 433, 463, 464,
    433, 464, 434, 434, 464, 465, 434, 465, 435, 435, 465, 466,
    435, 466, 436, 436, 466, 467, 436, 467, 437, 437, 467, 468,
    437, 468, 438, 438, 468, 469, 438, 469, 439, 439, 469, 470,
    439, 470, 440, 440, 470, 471, 440, 471, 441, 441, 471, 472,
    441, 472, 442, 442, 472, 473, 442, 473, 443, 443, 473, 474,
    443, 474, 444, 444, 474, 445, 444, 445, 415, 445, 475, 446,
    445, 446, 416, 446, 476, 477, 446, 477, 447, 417, 447, 478,
    417, 478, 448, 448, 478, 479, 448, 479, 449, 449, 479, 480,
    449, 480, 450, 450, 480, 481, 450, 481, 451, 451, 481, 482,
    451, 482, 452, 452, 482, 483, 452, 483, 453, 453, 483, 484,
    453, 484, 454, 454, 484, 485, 454, 485, 455, 455, 485, 486,
    455, 486, 456, 456, 486, 487, 456, 487, 457, 457, 487, 488,
    457, 488, 458, 458, 488, 489, 458, 489, 459, 459, 489, 490,
    459, 490, 460, 460, 490, 491, 460, 491, 461, 461, 491, 492,
    461, 492, 462, 462, 492, 493, 462, 493, 463, 463, 493, 494,
    463, 494, 464, 464, 494, 495, 464, 495, 465, 465, 495, 496,
    465, 496, 466, 466, 496, 497, 466, 497, 467, 467, 497, 498,
    467, 498, 468, 468, 498, 499, 468, 499, 469, 469, 499, 500,
    469, 500, 470, 470, 500, 501, 470, 501, 471, 471, 501, 502,
    471, 502, 472, 472, 502, 503, 472, 503, 473, 473, 503, 504,
    473, 504, 474, 474, 504, 475, 474, 475, 445, 475, 505, 476,
    475, 476, 446, 476, 506, 507, 476, 507, 477, 447, 477, 508,
    447, 508, 478, 478, 508, 509, 478, 509, 479, 479, 509, 510,
    479, 510, 480, 480, 510, 511, 480, 511, 481, 481, 511, 512,
    481, 512, 482, 482, 512, 513, 482, 513, 483, 483, 513, 514,
    483, 514, 484, 484, 514, 515, 484, 515, 485, 485, 515, 516,
    485, 516, 486, 486, 516, 517, 486, 517, 487, 487, 517, 518,
    487, 518, 488, 488, 518, 519, 488, 519, 489, 489, 519, 520,
    489, 520, 490, 490, 520, 521, 490, 521, 491, 491, 521, 522,
    491, 522, 492, 492, 522, 523, 492, 523, 493, 493, 523, 524,
    493, 524, 494, 494, 524, 525, 494, 525, 495, 495, 525, 526,
    495, 526, 496, 496, 526, 527, 496, 527, 497, 497, 527, 528,
    497, 528, 498, 498, 528, 529, 498, 529, 499, 499, 529, 530,
    499, 530, 500, 500, 530, 531, 500, 531, 501, 501, 531, 532,
    501, 532, 502, 502, 532, 533, 502, 533, 503, 503, 533, 534,
    503, 534, 504, 504, 534, 505, 504, 505, 475, 505, 535, 506,
    505, 506, 476, 506, 536, 537, 506, 537, 507, 477, 507, 538,
    477, 538, 508, 508, 538, 539, 508, 539, 509, 509, 539, 540,
    509, 540, 510, 510, 540, 541, 510, 541, 511, 511, 541, 542,
    511, 542, 512, 512, 542, 543, 512, 543, 513, 513, 543, 544,
    513, 544, 514, 514, 544, 545, 514, 545, 515, 515, 545, 546,
    515, 546, 516, 516, 546, 547, 516, 547, 517, 517, 547, 548,
    517, 548, 518, 518, 548, 549, 518, 549, 519, 519, 549, 550,
    519, 550, 520, 520, 550, 551, 520, 551, 521, 521, 551, 552,
    521, 552, 522, 522, 552, 553, 522, 553, 523, 523, 553, 554,
    523, 554, 524, 524, 554, 555, 524, 555, 525, 525, 555, 556,
    525, 556, 526, 526, 556, 557, 526, 557, 527, 527, 557, 558,
    527, 558, 528, 528, 558, 559, 528, 559, 529, 529, 559, 560,
    529, 560, 530, 530, 560, 561, 530, 561, 531, 531, 561, 562,
    531, 562, 532, 532, 562, 563, 532, 563, 533, 533, 563, 564,
    533, 564, 534, 534, 564, 535, 534, 535, 505, 535, 565, 536,
    535, 536, 506, 536, 566, 567, 536, 567, 537, 507, 537, 568,
    507, 568, 538, 538, 568, 569, 538, 569, 539, 539, 569, 570,
    539, 570, 540, 540, 570, 571, 540, 571, 541, 541, 571, 572,
    541, 572, 542, 542, 572, 573, 542, 573, 543, 543, 573, 574,
    543, 574, 544, 544, 574, 575, 544, 575, 545, 545, 575, 576,
    545, 576, 546, 546, 576, 577, 546, 577, 547, 547, 577, 578,
    547, 578, 548, 548, 578, 579, 548, 579, 549, 549, 579, 580,
    549, 580, 550, 550, 580, 581, 550, 581, 551, 551, 581, 582,
    551, 582, 552, 552, 582, 583, 552, 583, 553, 553, 583, 584,
    553, 584, 554, 554, 584, 585, 554, 585, 555, 555, 585, 586,
    555, 586, 556, 556, 586, 587, 556, 587, 557, 557, 587, 588,
    557, 588, 558, 558, 588, 589, 558, 589, 559, 559, 589, 590,
    559, 590, 560, 560, 590, 591, 560, 591, 561, 561, 591, 592,
    561, 592, 562, 562, 592, 593, 562, 593, 563, 563, 593, 594,
    563, 594, 564, 564, 594, 565, 564, 565, 535, 565, 595, 566,
    565, 566, 536, 566, 596, 567, 537, 567, 597, 537, 597, 568,
    568, 597, 598, 568, 598, 569, 569, 598, 599, 569, 599, 570,
    570, 599, 600, 570, 600, 571, 571, 600, 601, 571, 601, 572,
    572, 601, 602, 572, 602, 573, 573, 602, 603, 573, 603, 574,
    574, 603, 604, 574, 604, 575, 575, 604, 605, 575, 605, 576,
    576, 605, 606, 576, 606, 577, 577, 606, 607, 577, 607, 578,
    578, 607, 608, 578, 608, 579, 579, 608, 609, 579, 609, 580,
    580, 609, 610, 580, 610, 581, 581, 610, 611, 581, 611, 582,
    582, 611, 612, 582, 612, 583, 583, 612, 613, 583, 613, 584,
    584, 613, 614, 584, 614, 585, 585, 614, 615, 585, 615, 586,
    586, 615, 616, 586, 616, 587, 587, 616, 617, 587, 617, 588,
    588, 617, 618, 588, 618, 589, 589, 618, 619, 589, 619, 590,
    590, 619, 620, 590, 620, 591, 591, 620, 621, 591, 621, 592,
    592, 621, 622, 592, 622, 593, 593, 622, 623, 593, 623, 594,
    594, 623, 595, 594, 595, 565, 595, 596, 566, 567, 596, 597,
    597, 596, 598, 598, 596, 599, 599, 596, 600, 600, 596, 601,
    601, 596, 602, 602, 596, 603, 603, 596, 604, 604, 596, 605,
    605, 596, 606, 606, 596, 607, 607, 596, 608, 608, 596, 609,
    609, 596, 610, 610, 596, 611, 611, 596, 612, 612, 596, 613,
    613, 596, 614, 614, 596, 615, 615, 596, 616, 616, 596, 617,
    617, 596, 618, 618, 596, 619, 619, 596, 620, 620, 596, 621,
    621, 596, 622, 622, 596, 623, 623, 596, 595, 54, 51, 624,
    54, 624, 625, 56, 54, 625, 56, 625, 626, 51, 50, 627,
    51, 627, 624, 58, 56, 626, 58, 626, 636, 23, 58, 636,
    23, 636, 634, 26, 23, 635, 26, 635, 633, 28, 26, 633,
    28, 633, 632, 29, 28, 632, 29, 632, 631, 31, 29, 631,
    31, 631, 629, 34, 32, 630, 34, 630, 628, 50, 34, 628,
    50, 628, 627, 43, 41, 637, 43, 637, 638, 45, 43, 638,
    45, 638, 639, 55, 57, 59, 59, 24, 22, 59, 22, 60,
    74, 75, 52, 72, 73, 74, 70, 71, 72, 68, 69, 70,
    19, 17, 68, 67, 19, 68, 68, 70, 72, 72, 74, 52,
    55, 59, 60, 55, 60, 63, 72, 52, 55, 67, 68, 72,
    55, 63, 65, 65, 67, 72, 55, 65, 72, 41, 40, 640,
    41, 640, 637, 47, 45, 639, 47, 639, 646, 37, 47, 646,
    37, 646, 641, 649, 652, 642, 649, 642, 645, 654, 647, 644,
    654, 644, 643, 650, 654, 643, 650, 643, 642, 40, 37, 641,
    40, 641, 640, 62, 61, 655, 62, 655, 656, 64, 62, 656,
    64, 656, 657, 61, 21, 658, 61, 658, 655, 66, 64, 657,
    66, 657, 661, 666, 668, 662, 666, 662, 665, 671, 666, 665,
    671, 665, 664, 670, 671, 664, 670, 664, 663, 18, 66, 661,
    18, 661, 660, 21, 20, 659, 21, 659, 658, 667, 672, 669,
    49, 48, 38, 49, 38, 35, 75, 76, 77, 77, 78, 79,
    79, 80, 81, 81, 0, 3, 3, 4, 5, 5, 6, 7,
    7, 8, 9, 9, 10, 11, 11, 12, 13, 13, 14, 15,
    15, 16, 17, 17, 19, 22, 22, 24, 25, 15, 17, 22,
    11, 13, 15, 7, 9, 11, 3, 5, 7, 79, 81, 3,
    75, 77, 79, 49, 53, 75, 46, 48, 49, 44, 46, 49,
    49, 75, 79, 11, 15, 22, 11, 22, 25, 44, 49, 79,
    44, 79, 3, 7, 11, 25, 7, 25, 27, 42, 44, 3,
    36, 38, 39, 39, 42, 3, 30, 33, 36, 39, 3, 7,
    30, 36, 39, 39, 7, 27, 27, 30, 39,
  ]),
  normals: new Float32Array([
    -0.05980062, 0.99821034, 0.00000000,
    -0.22980847, 0.97323587, 0.00000000,
    -0.22471200, 0.97325199, -0.04780255,
    -0.05850061, 0.99821036, -0.01240013,
    -0.05460068, 0.99821253, -0.02430030,
    -0.04840054, 0.99821108, -0.03510039,
    -0.04000051, 0.99821268, -0.04440056,
    -0.02990029, 0.99820974, -0.05180051,
    -0.01850016, 0.99820844, -0.05690048,
    -0.00630005, 0.99820839, -0.05950050,
    0.00630005, 0.99820839, -0.05950050,
    0.01850016, 0.99820844, -0.05690048,
    0.02990029, 0.99820974, -0.05180051,
    0.04000051, 0.99821268, -0.04440056,
    0.04840054, 0.99821108, -0.03510039,
    0.05460068, 0.99821253, -0.02430030,
    0.05850061, 0.99821036, -0.01240013,
    0.06430197, 0.99793049, 0.00000000,
    -0.56118324, 0.82627535, 0.04839855,
    -0.56118324, 0.82627535, 0.04839855,
    -0.56122965, 0.82624359, 0.04840255,
    0.00020000, -0.95808184, 0.28649458,
    0.00020000, -0.95808184, 0.28649458,
    -0.26209663, 0.95058777, 0.16639785,
    -0.26209663, 0.95058777, 0.16639785,
    -0.04419780, -0.69166563, 0.72086421,
    -0.04420099, -0.69171550, 0.72081616,
    0.69193287, -0.55962659, 0.45612166,
    0.69189416, -0.55969529, 0.45609610,
    0.43801611, -0.60012202, -0.66932462,
    0.43798979, -0.60018603, -0.66928445,
    0.56917839, 0.57717811, -0.58557783,
    0.56911082, 0.57721097, -0.58561111,
    0.56911082, 0.57721097, -0.58561111,
    0.89479144, 0.36979647, 0.25019761,
    0.89479144, 0.36979647, 0.25019761,
    0.89476906, 0.36978721, 0.25029134,
    -0.44831673, 0.89373334, 0.01590060,
    -0.44831673, 0.89373334, 0.01590060,
    0.00060000, -0.54720080, 0.83700115,
    0.00059998, -0.54708488, 0.83707692,
    0.68070211, -0.69340219, 0.23630074,
    0.68070211, -0.69340219, 0.23630074,
    0.76038811, -0.60169057, -0.24449617,
    0.76038811, -0.60169057, -0.24449617,
    0.02209999, -0.59299959, -0.80489942,
    0.02209999, -0.59299959, -0.80489942,
    -0.61440034, -0.64430030, -0.45540021,
    -0.61440034, -0.64430030, -0.45540021,
    0.74112559, -0.55591917, -0.37641299,
    0.74108439, -0.55598825, -0.37639207,
    -0.70658709, -0.55228986, -0.44239190,
    -0.70662607, -0.55222041, -0.44241634,
    -0.70667617, -0.55218135, -0.44238507,
    -0.75871474, 0.63751239, 0.13390261,
    -0.75871474, 0.63751239, 0.13390261,
    -0.51190041, 0.58540045, -0.62870048,
    -0.51190041, 0.58540045, -0.62870048,
    -0.46559584, -0.59349471, -0.65649413,
    -0.46559584, -0.59349471, -0.65649413,
    0.68798183, -0.68928175, 0.22709399,
    0.68792913, -0.68932919, 0.22710962,
    0.75717229, -0.60657782, -0.24239114,
    0.75717229, -0.60657782, -0.24239114,
    0.03489951, -0.59049177, -0.80628872,
    0.03489951, -0.59049177, -0.80628872,
    -0.64250925, -0.63620922, -0.42710619,
    -0.64250925, -0.63620922, -0.42710619,
    0.05850061, 0.99821036, 0.01240013,
    0.05460068, 0.99821253, 0.02430030,
    0.04840054, 0.99821108, 0.03510039,
    0.04000051, 0.99821268, 0.04440056,
    0.02990029, 0.99820974, 0.05180051,
    0.01850016, 0.99820844, 0.05690048,
    0.00630005, 0.99820839, 0.05950050,
    -0.00630005, 0.99820839, 0.05950050,
    -0.01850016, 0.99820844, 0.05690048,
    -0.02990029, 0.99820974, 0.05180051,
    -0.04000051, 0.99821268, 0.04440056,
    -0.04840054, 0.99821108, 0.03510039,
    -0.05460068, 0.99821253, 0.02430030,
    -0.05850061, 0.99821036, 0.01240013,
    -0.22471200, 0.97325199, 0.04780255,
    -0.43979830, 0.89809657, 0.00000000,
    -0.43019793, 0.89809568, -0.09139956,
    -0.20969890, 0.97329487, -0.09339951,
    -0.18590659, 0.97323452, -0.13510480,
    -0.15350420, 0.97332658, -0.17050465,
    -0.11470283, 0.97332401, -0.19870490,
    -0.07100194, 0.97322667, -0.21860598,
    -0.02400098, 0.97333966, -0.22810930,
    0.02400098, 0.97333966, -0.22810930,
    0.07100194, 0.97322667, -0.21860598,
    0.11469394, 0.97334861, -0.19858950,
    0.15350420, 0.97332658, -0.17050465,
    0.18590659, 0.97323452, -0.13510480,
    0.20950767, 0.97333567, -0.09340342,
    0.22471200, 0.97325199, -0.04780255,
    0.22980847, 0.97323587, 0.00000000,
    0.22471200, 0.97325199, 0.04780255,
    0.20969890, 0.97329487, 0.09339951,
    0.18590659, 0.97323452, 0.13510480,
    0.15369423, 0.97326347, 0.17069359,
    0.11480380, 0.97333217, 0.19860657,
    0.07099814, 0.97327447, 0.21839428,
    0.02399864, 0.97334492, 0.22808710,
    -0.02399864, 0.97334492, 0.22808710,
    -0.07099814, 0.97327447, 0.21839428,
    -0.11480380, 0.97333217, 0.19860657,
    -0.15369423, 0.97326347, 0.17069359,
    -0.18590659, 0.97323452, 0.13510480,
    -0.20950767, 0.97333567, 0.09340342,
    -0.43019793, 0.89809568, 0.09139956,
    -0.62761756, 0.77852180, 0.00000000,
    -0.61391052, 0.77851335, -0.13050224,
    -0.40179357, 0.89808560, -0.17889713,
    -0.35598830, 0.89797051, -0.25869151,
    -0.29420948, 0.89812898, -0.32681054,
    -0.22000385, 0.89801571, -0.38100668,
    -0.13590467, 0.89803082, -0.41841435,
    -0.04599958, 0.89809176, -0.43739597,
    0.04600148, 0.89822890, -0.43711407,
    0.13590467, 0.89803082, -0.41841435,
    0.22000385, 0.89801571, -0.38100668,
    0.29420948, 0.89812898, -0.32681054,
    0.35580008, 0.89810023, -0.25850006,
    0.40179357, 0.89808560, -0.17889713,
    0.43019793, 0.89809568, -0.09139956,
    0.43979830, 0.89809657, 0.00000000,
    0.43019793, 0.89809568, 0.09139956,
    0.40179357, 0.89808560, 0.17889713,
    0.35598830, 0.89797051, 0.25869151,
    0.29429121, 0.89807319, 0.32689024,
    0.21989731, 0.89808903, 0.38089534,
    0.13590383, 0.89812531, 0.41821177,
    0.04599958, 0.89809176, 0.43739597,
    -0.04599958, 0.89809176, 0.43739597,
    -0.13590383, 0.89812531, 0.41821177,
    -0.21989731, 0.89808903, 0.38089534,
    -0.29429121, 0.89807319, 0.32689024,
    -0.35580008, 0.89810023, 0.25850006,
    -0.40179357, 0.89808560, 0.17889713,
    -0.61391052, 0.77851335, 0.13050224,
    -0.78477526, 0.61978044, 0.00000000,
    -0.76738911, 0.62009120, -0.16309769,
    -0.57343668, 0.77844972, -0.25531629,
    -0.50798741, 0.77828063, -0.36909084,
    -0.42017314, 0.77825028, -0.46667016,
    -0.31398975, 0.77827458, -0.54378223,
    -0.19409639, 0.77818545, -0.59728888,
    -0.06560022, 0.77810270, -0.62470216,
    0.06560022, 0.77810270, -0.62470216,
    0.19409639, 0.77818545, -0.59728888,
    0.31398975, 0.77827458, -0.54378223,
    0.42017314, 0.77825028, -0.46667016,
    0.50798741, 0.77828063, -0.36909084,
    0.57343668, 0.77844972, -0.25531629,
    0.61391052, 0.77851335, -0.13050224,
    0.62761756, 0.77852180, 0.00000000,
    0.61391052, 0.77851335, 0.13050224,
    0.57343668, 0.77844972, 0.25531629,
    0.50798741, 0.77828063, 0.36909084,
    0.42009080, 0.77828296, 0.46668977,
    0.31389223, 0.77838077, 0.54368654,
    0.19399664, 0.77828648, 0.59718964,
    0.06550375, 0.77824445, 0.62453569,
    -0.06550375, 0.77824445, 0.62453569,
    -0.19399664, 0.77828648, 0.59718964,
    -0.31389223, 0.77838077, 0.54368654,
    -0.42009080, 0.77828296, 0.46668977,
    -0.50798741, 0.77828063, 0.36909084,
    -0.57343668, 0.77844972, 0.25531629,
    -0.76738911, 0.62009120, 0.16309769,
    -0.90236087, 0.43098128, 0.00000000,
    -0.88288393, 0.43049215, -0.18759658,
    -0.71683475, 0.61993005, -0.31911547,
    -0.63481510, 0.61991472, -0.46121094,
    -0.52517318, 0.61966842, -0.58327025,
    -0.39229617, 0.61999393, -0.67949337,
    -0.24250947, 0.61982417, -0.74632912,
    -0.08190100, 0.62000751, -0.78030950,
    0.08199901, 0.61989253, -0.78039055,
    0.24250947, 0.61982417, -0.74632912,
    0.39229384, 0.61989022, -0.67958933,
    0.52517318, 0.61966842, -0.58327025,
    0.63481510, 0.61991472, -0.46121094,
    0.71683475, 0.61993005, -0.31911547,
    0.76738911, 0.62009120, -0.16309769,
    0.78477526, 0.61978044, 0.00000000,
    0.76738911, 0.62009120, 0.16309769,
    0.71683475, 0.61993005, 0.31911547,
    0.63481510, 0.61991472, 0.46121094,
    0.52512562, 0.62003028, 0.58292841,
    0.39229617, 0.61999393, 0.67949337,
    0.24258547, 0.61976287, 0.74635532,
    0.08210096, 0.62010733, 0.78020916,
    -0.08210096, 0.62010733, 0.78020916,
    -0.24258547, 0.61976287, 0.74635532,
    -0.39229617, 0.61999393, 0.67949337,
    -0.52509887, 0.61979868, 0.58319874,
    -0.63481510, 0.61991472, 0.46121094,
    -0.71683475, 0.61993005, 0.31911547,
    -0.88268771, 0.43089400, 0.18759738,
    -0.97529663, 0.22089924, 0.00000000,
    -0.95400508, 0.22060116, -0.20300107,
    -0.82437009, 0.43088436, -0.36708668,
    -0.73021001, 0.43040592, -0.53060728,
    -0.60376194, 0.43107287, -0.67055776,
    -0.45111705, 0.43111632, -0.78142954,
    -0.27880033, 0.43100049, -0.85820100,
    -0.09430093, 0.43100424, -0.89740887,
    0.09429620, 0.43068263, -0.89756376,
    0.27880033, 0.43100049, -0.85820100,
    0.45129943, 0.43079946, -0.78149898,
    0.60378798, 0.43099142, -0.67058666,
    0.73007632, 0.43078602, -0.53048277,
    0.82437009, 0.43088436, -0.36708668,
    0.88288393, 0.43049215, -0.18759658,
    0.90230338, 0.43110161, 0.00000000,
    0.88262757, 0.43101348, 0.18760586,
    0.82433277, 0.43101713, 0.36701461,
    0.73021001, 0.43040592, 0.53060728,
    0.60376194, 0.43107287, 0.67055776,
    0.45111705, 0.43111632, 0.78142954,
    0.27880033, 0.43100049, 0.85820100,
    0.09430093, 0.43100424, 0.89740887,
    -0.09429620, 0.43068263, 0.89756376,
    -0.27869606, 0.43109396, 0.85818792,
    -0.45111705, 0.43111632, 0.78142954,
    -0.60380243, 0.43110176, 0.67050271,
    -0.73007632, 0.43078602, 0.53048277,
    -0.82433277, 0.43101713, 0.36701461,
    -0.95404379, 0.22061011, 0.20280932,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.99844184, 0.05580234, 0.00000000,
    -0.97662549, 0.05570145, -0.20760542,
    -0.97662549, 0.05570145, -0.20760542,
    -0.89097426, 0.22109362, -0.39658855,
    -0.78902109, 0.22080592, -0.57331533,
    -0.65260832, 0.22080282, -0.72480928,
    -0.48759211, 0.22119642, -0.84458633,
    -0.30139453, 0.22079598, -0.92758314,
    -0.10189677, 0.22129300, -0.96986930,
    0.10189677, 0.22129300, -0.96986930,
    0.30139453, 0.22079598, -0.92758314,
    0.48759211, 0.22119642, -0.84458633,
    0.65250764, 0.22110260, -0.72480854,
    0.78902109, 0.22080592, -0.57331533,
    0.89097426, 0.22109362, -0.39658855,
    0.95400508, 0.22060116, -0.20300107,
    0.97529663, 0.22089924, 0.00000000,
    0.95404379, 0.22061011, 0.20280932,
    0.89097426, 0.22109362, 0.39658855,
    0.78902109, 0.22080592, 0.57331533,
    0.65260832, 0.22080282, 0.72480928,
    0.48760288, 0.22110131, 0.84460502,
    0.30138787, 0.22089110, 0.92756265,
    0.10189903, 0.22119788, 0.96989076,
    -0.10189677, 0.22129300, 0.96986930,
    -0.30140915, 0.22100672, 0.92752820,
    -0.48779650, 0.22109842, 0.84449397,
    -0.65238854, 0.22119611, 0.72488722,
    -0.78902109, 0.22080592, 0.57331533,
    -0.89097426, 0.22109362, 0.39658855,
    -0.97662004, 0.05580114, 0.20760425,
    -0.97662004, 0.05580114, 0.20760425,
    -1.00000000, 0.00000000, 0.00000000,
    -1.00000000, 0.00000000, 0.00000000,
    -0.97814792, 0.00000000, -0.20791019,
    -0.91216314, 0.05599774, -0.40598357,
    -0.91216314, 0.05599774, -0.40598357,
    -0.80775714, 0.05579704, -0.58686889,
    -0.80775714, 0.05579704, -0.58686889,
    -0.66813405, 0.05590285, -0.74193784,
    -0.66813405, 0.05590285, -0.74193784,
    -0.49938821, 0.05579868, -0.86457962,
    -0.49938821, 0.05579868, -0.86457962,
    -0.30861232, 0.05600223, -0.94953788,
    -0.30861232, 0.05600223, -0.94953788,
    -0.10439501, 0.05609732, -0.99295255,
    -0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.10439501, 0.05609732, -0.99295255,
    0.30861232, 0.05600223, -0.94953788,
    0.30861232, 0.05600223, -0.94953788,
    0.49938821, 0.05579868, -0.86457962,
    0.49938821, 0.05579868, -0.86457962,
    0.66813405, 0.05590285, -0.74193784,
    0.66813405, 0.05590285, -0.74193784,
    0.80780907, 0.05570062, -0.58680656,
    0.80780907, 0.05570062, -0.58680656,
    0.91216314, 0.05599774, -0.40598357,
    0.91216314, 0.05599774, -0.40598357,
    0.97662549, 0.05570145, -0.20760542,
    0.97662549, 0.05570145, -0.20760542,
    0.99844184, 0.05580234, 0.00000000,
    0.99844184, 0.05580234, 0.00000000,
    0.97662004, 0.05580114, 0.20760425,
    0.97662004, 0.05580114, 0.20760425,
    0.91205048, 0.05569697, 0.40627795,
    0.91205048, 0.05569697, 0.40627795,
    0.80775714, 0.05579704, 0.58686889,
    0.80775714, 0.05579704, 0.58686889,
    0.66813405, 0.05590285, 0.74193784,
    0.66813405, 0.05590285, 0.74193784,
    0.49931595, 0.05570178, 0.86462760,
    0.49931595, 0.05570178, 0.86462760,
    0.30849597, 0.05579927, 0.94958764,
    0.30849597, 0.05579927, 0.94958764,
    0.10439560, 0.05599764, 0.99295812,
    0.10439560, 0.05599764, 0.99295812,
    -0.10439501, 0.05609732, 0.99295255,
    -0.10439501, 0.05609732, 0.99295255,
    -0.30861403, 0.05590254, 0.94954320,
    -0.30861403, 0.05590254, 0.94954320,
    -0.49932150, 0.05550239, 0.86463722,
    -0.49932150, 0.05550239, 0.86463722,
    -0.66819688, 0.05569974, 0.74189653,
    -0.66819688, 0.05569974, 0.74189653,
    -0.80780907, 0.05570062, 0.58680656,
    -0.80780907, 0.05570062, 0.58680656,
    -0.91215802, 0.05609742, 0.40598131,
    -0.91215802, 0.05609742, 0.40598131,
    -0.97814792, 0.00000000, 0.20791019,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.99844184, -0.05580234, 0.00000000,
    -0.97662549, -0.05570145, -0.20760542,
    -0.97662549, -0.05570145, -0.20760542,
    -0.91360525, 0.00000000, -0.40660231,
    -0.80895657, 0.00000000, -0.58786841,
    -0.66913599, 0.00000000, -0.74313998,
    -0.50012935, 0.00000000, -0.86595071,
    -0.30910870, 0.00000000, -0.95102672,
    -0.10460149, 0.00000000, -0.99451422,
    0.10460149, 0.00000000, -0.99451422,
    0.30910870, 0.00000000, -0.95102672,
    0.50012935, 0.00000000, -0.86595071,
    0.66913599, 0.00000000, -0.74313998,
    0.80895657, 0.00000000, -0.58786841,
    0.91360525, 0.00000000, -0.40660231,
    0.97814792, 0.00000000, -0.20791019,
    1.00000000, 0.00000000, 0.00000000,
    0.97814792, 0.00000000, 0.20791019,
    0.91360525, 0.00000000, 0.40660231,
    0.80895657, 0.00000000, 0.58786841,
    0.66913599, 0.00000000, 0.74313998,
    0.50001101, 0.00000000, 0.86601905,
    0.30910870, 0.00000000, 0.95102672,
    0.10460149, 0.00000000, 0.99451422,
    -0.10460149, 0.00000000, 0.99451422,
    -0.30910870, 0.00000000, 0.95102672,
    -0.50012935, 0.00000000, 0.86595071,
    -0.66913599, 0.00000000, 0.74313998,
    -0.80895657, 0.00000000, 0.58786841,
    -0.91360525, 0.00000000, 0.40660231,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97662004, -0.05580114, 0.20760425,
    -0.97527509, -0.22099435, 0.00000000,
    -0.95393118, -0.22100722, -0.20290665,
    -0.91216314, -0.05599774, -0.40598357,
    -0.91216314, -0.05599774, -0.40598357,
    -0.80780907, -0.05570062, -0.58680656,
    -0.80780907, -0.05570062, -0.58680656,
    -0.66813405, -0.05590285, -0.74193784,
    -0.66813405, -0.05590285, -0.74193784,
    -0.49938821, -0.05579868, -0.86457962,
    -0.49938821, -0.05579868, -0.86457962,
    -0.30861232, -0.05600223, -0.94953788,
    -0.30861232, -0.05600223, -0.94953788,
    -0.10439501, -0.05609732, -0.99295255,
    -0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.10439501, -0.05609732, -0.99295255,
    0.30861232, -0.05600223, -0.94953788,
    0.30861232, -0.05600223, -0.94953788,
    0.49938821, -0.05579868, -0.86457962,
    0.49938821, -0.05579868, -0.86457962,
    0.66813405, -0.05590285, -0.74193784,
    0.66813405, -0.05590285, -0.74193784,
    0.80780907, -0.05570062, -0.58680656,
    0.80780907, -0.05570062, -0.58680656,
    0.91216314, -0.05599774, -0.40598357,
    0.91216314, -0.05599774, -0.40598357,
    0.97662549, -0.05570145, -0.20760542,
    0.97662549, -0.05570145, -0.20760542,
    0.99844184, -0.05580234, 0.00000000,
    0.99844184, -0.05580234, 0.00000000,
    0.97662004, -0.05580114, 0.20760425,
    0.97662004, -0.05580114, 0.20760425,
    0.91208245, -0.05579893, 0.40619217,
    0.91208245, -0.05579893, 0.40619217,
    0.80780907, -0.05570062, 0.58680656,
    0.80780907, -0.05570062, 0.58680656,
    0.66813405, -0.05590285, 0.74193784,
    0.66813405, -0.05590285, 0.74193784,
    0.49931595, -0.05570178, 0.86462760,
    0.49931595, -0.05570178, 0.86462760,
    0.30849597, -0.05579927, 0.94958764,
    0.30849597, -0.05579927, 0.94958764,
    0.10439560, -0.05599764, 0.99295812,
    0.10439560, -0.05599764, 0.99295812,
    -0.10439501, -0.05609732, 0.99295255,
    -0.10439501, -0.05609732, 0.99295255,
    -0.30861403, -0.05590254, 0.94954320,
    -0.30861403, -0.05590254, 0.94954320,
    -0.49918934, -0.05599880, 0.86468152,
    -0.49918934, -0.05599880, 0.86468152,
    -0.66819688, -0.05569974, 0.74189653,
    -0.66819688, -0.05569974, 0.74189653,
    -0.80780907, -0.05570062, 0.58680656,
    -0.80780907, -0.05570062, 0.58680656,
    -0.91208245, -0.05579893, 0.40619217,
    -0.91208245, -0.05579893, 0.40619217,
    -0.95395953, -0.22099063, 0.20279139,
    -0.90239973, -0.43089990, 0.00000000,
    -0.88268771, -0.43089400, -0.18759738,
    -0.89091830, -0.22110454, -0.39670815,
    -0.78902109, -0.22080592, -0.57331533,
    -0.65259796, -0.22119932, -0.72469771,
    -0.48761365, -0.22100619, -0.84462370,
    -0.30138787, -0.22089110, -0.92756265,
    -0.10190352, -0.22100767, -0.96993365,
    0.10190352, -0.22100767, -0.96993365,
    0.30138787, -0.22089110, -0.92756265,
    0.48762444, -0.22091107, -0.84464235,
    0.65259796, -0.22119932, -0.72469771,
    0.78895134, -0.22118637, -0.57326466,
    0.89099798, -0.22079950, -0.39669909,
    0.95393118, -0.22100722, -0.20290665,
    0.97527509, -0.22099435, 0.00000000,
    0.95395953, -0.22099063, 0.20279139,
    0.89101765, -0.22070437, 0.39670785,
    0.78902109, -0.22080592, 0.57331533,
    0.65259796, -0.22119932, 0.72469771,
    0.48762444, -0.22091107, 0.84464235,
    0.30139453, -0.22079598, 0.92758314,
    0.10189815, -0.22079600, 0.96998242,
    -0.10190352, -0.22100767, 0.96993365,
    -0.30139453, -0.22079598, 0.92758314,
    -0.48761365, -0.22100619, 0.84462370,
    -0.65257545, -0.22069170, 0.72487272,
    -0.78895134, -0.22118637, 0.57326466,
    -0.89101765, -0.22070437, 0.39670785,
    -0.88270918, -0.43080445, 0.18770195,
    -0.78468818, -0.61989069, 0.00000000,
    -0.76738911, -0.62009120, -0.16309769,
    -0.82440561, -0.43080291, -0.36710250,
    -0.73010776, -0.43070458, -0.53050564,
    -0.60379085, -0.43129347, -0.67038986,
    -0.45117726, -0.43117823, -0.78136061,
    -0.27869596, -0.43129376, -0.85808756,
    -0.09429687, -0.43108568, -0.89737018,
    0.09429687, -0.43108568, -0.89737018,
    0.27869596, -0.43129376, -0.85808756,
    0.45121980, -0.43081888, -0.78153425,
    0.60377641, -0.43118315, -0.67047382,
    0.73010776, -0.43070458, -0.53050564,
    0.82440561, -0.43080291, -0.36710250,
    0.88268771, -0.43089400, -0.18759738,
    0.90226449, -0.43118302, 0.00000000,
    0.88270918, -0.43080445, 0.18770195,
    0.82447315, -0.43068597, 0.36708803,
    0.73010776, -0.43070458, 0.53050564,
    0.60379085, -0.43129347, 0.67038986,
    0.45117726, -0.43117823, 0.78136061,
    0.27869596, -0.43129376, 0.85808756,
    0.09429687, -0.43108568, 0.89737018,
    -0.09429687, -0.43108568, 0.89737018,
    -0.27878830, -0.43108192, 0.85816401,
    -0.45111705, -0.43111632, 0.78142954,
    -0.60378798, -0.43099142, 0.67058666,
    -0.73010776, -0.43070458, 0.53050564,
    -0.82433277, -0.43101713, 0.36701461,
    -0.76738911, -0.62009120, 0.16309769,
    -0.62761756, -0.77852180, 0.00000000,
    -0.61391052, -0.77851335, -0.13050224,
    -0.71683475, -0.61993005, -0.31911547,
    -0.63481510, -0.61991472, -0.46121094,
    -0.52509499, -0.61999411, -0.58299447,
    -0.39229617, -0.61999393, -0.67949337,
    -0.24260050, -0.61970132, -0.74640155,
    -0.08190100, -0.62000751, -0.78030950,
    0.08220010, -0.61960083, -0.78060102,
    0.24260050, -0.61970132, -0.74640155,
    0.39231817, -0.61982866, -0.67963143,
    0.52517318, -0.61966842, -0.58327025,
    0.63481510, -0.61991472, -0.46121094,
    0.71683475, -0.61993005, -0.31911547,
    0.76738911, -0.62009120, -0.16309769,
    0.78468818, -0.61989069, 0.00000000,
    0.76738911, -0.62009120, 0.16309769,
    0.71683475, -0.61993005, 0.31911547,
    0.63481510, -0.61991472, 0.46121094,
    0.52519610, -0.62009539, 0.58279564,
    0.39229617, -0.61999393, 0.67949337,
    0.24258547, -0.61976287, 0.74635532,
    0.08210096, -0.62010733, 0.78020916,
    -0.08210096, -0.62010733, 0.78020916,
    -0.24258547, -0.61976287, 0.74635532,
    -0.39229850, -0.62009760, 0.67939742,
    -0.52509887, -0.61979868, 0.58319874,
    -0.63481510, -0.61991472, 0.46121094,
    -0.71683475, -0.61993005, 0.31911547,
    -0.61391052, -0.77851335, 0.13050224,
    -0.43979830, -0.89809657, 0.00000000,
    -0.43019793, -0.89809568, -0.09139956,
    -0.57371263, -0.77821706, -0.25540560,
    -0.50798741, -0.77828063, -0.36909084,
    -0.42017314, -0.77825028, -0.46667016,
    -0.31398975, -0.77827458, -0.54378223,
    -0.19409639, -0.77818545, -0.59728888,
    -0.06560022, -0.77810270, -0.62470216,
    0.06560022, -0.77810270, -0.62470216,
    0.19409639, -0.77818545, -0.59728888,
    0.31398975, -0.77827458, -0.54378223,
    0.42017314, -0.77825028, -0.46667016,
    0.50798741, -0.77828063, -0.36909084,
    0.57371263, -0.77821706, -0.25540560,
    0.61391052, -0.77851335, -0.13050224,
    0.62761756, -0.77852180, 0.00000000,
    0.61391052, -0.77851335, 0.13050224,
    0.57371263, -0.77821706, 0.25540560,
    0.50798741, -0.77828063, 0.36909084,
    0.42009080, -0.77828296, 0.46668977,
    0.31389223, -0.77838077, 0.54368654,
    0.19399664, -0.77828648, 0.59718964,
    0.06550375, -0.77824445, 0.62453569,
    -0.06550375, -0.77824445, 0.62453569,
    -0.19399664, -0.77828648, 0.59718964,
    -0.31389223, -0.77838077, 0.54368654,
    -0.42009080, -0.77828296, 0.46668977,
    -0.50798741, -0.77828063, 0.36909084,
    -0.57371263, -0.77821706, 0.25540560,
    -0.43019793, -0.89809568, 0.09139956,
    -0.22980847, -0.97323587, 0.00000000,
    -0.22471200, -0.97325199, -0.04780255,
    -0.40179357, -0.89808560, -0.17889713,
    -0.35580008, -0.89810023, -0.25850006,
    -0.29449069, -0.89797161, -0.32698964,
    -0.22000385, -0.89801571, -0.38100668,
    -0.13590467, -0.89803082, -0.41841435,
    -0.04600148, -0.89822890, -0.43711407,
    0.04600148, -0.89822890, -0.43711407,
    0.13589899, -0.89799323, -0.41849686,
    0.22000385, -0.89801571, -0.38100668,
    0.29420948, -0.89812898, -0.32681054,
    0.35580008, -0.89810023, -0.25850006,
    0.40179357, -0.89808560, -0.17889713,
    0.43019793, -0.89809568, -0.09139956,
    0.43979830, -0.89809657, 0.00000000,
    0.43019793, -0.89809568, 0.09139956,
    0.40179357, -0.89808560, 0.17889713,
    0.35580008, -0.89810023, 0.25850006,
    0.29429121, -0.89807319, 0.32689024,
    0.21989731, -0.89808903, 0.38089534,
    0.13590383, -0.89812531, 0.41821177,
    0.04599958, -0.89809176, 0.43739597,
    -0.04599958, -0.89809176, 0.43739597,
    -0.13590383, -0.89812531, 0.41821177,
    -0.21989731, -0.89808903, 0.38089534,
    -0.29429121, -0.89807319, 0.32689024,
    -0.35580008, -0.89810023, 0.25850006,
    -0.40179357, -0.89808560, 0.17889713,
    -0.22471200, -0.97325199, 0.04780255,
    -0.05999990, -0.99819838, 0.00000000,
    -0.05850061, -0.99821036, -0.01240013,
    -0.20969890, -0.97329487, -0.09339951,
    -0.18590659, -0.97323452, -0.13510480,
    -0.15370656, -0.97324157, -0.17080729,
    -0.11490453, -0.97323832, -0.19900783,
    -0.07100194, -0.97322667, -0.21860598,
    -0.02400098, -0.97333966, -0.22810930,
    0.02399879, -0.97325079, -0.22848844,
    0.07100194, -0.97322667, -0.21860598,
    0.11490453, -0.97323832, -0.19900783,
    0.15350420, -0.97332658, -0.17050465,
    0.18590659, -0.97323452, -0.13510480,
    0.20950767, -0.97333567, -0.09340342,
    0.22471200, -0.97325199, -0.04780255,
    0.22980847, -0.97323587, 0.00000000,
    0.22471200, -0.97325199, 0.04780255,
    0.20969890, -0.97329487, 0.09339951,
    0.18590659, -0.97323452, 0.13510480,
    0.15369160, -0.97324685, 0.17079067,
    0.11480380, -0.97333217, 0.19860657,
    0.07099814, -0.97327447, 0.21839428,
    0.02399864, -0.97334492, 0.22808710,
    -0.02399864, -0.97334492, 0.22808710,
    -0.07099814, -0.97327447, 0.21839428,
    -0.11480380, -0.97333217, 0.19860657,
    -0.15369160, -0.97324685, 0.17079067,
    -0.18590659, -0.97323452, 0.13510480,
    -0.20950767, -0.97333567, 0.09340342,
    -0.05850061, -0.99821036, 0.01240013,
    0.00000000, -1.00000000, 0.00000000,
    -0.05509891, -0.99818029, -0.02449951,
    -0.04859973, -0.99819437, -0.03529980,
    -0.04039896, -0.99817434, -0.04489885,
    -0.02990014, -0.99820456, -0.05190024,
    -0.01850026, -0.99821411, -0.05680080,
    -0.00630005, -0.99820839, -0.05950050,
    0.00630005, -0.99820839, -0.05950050,
    0.01850026, -0.99821411, -0.05680080,
    0.02999989, -0.99819639, -0.05199981,
    0.04039896, -0.99817434, -0.04489885,
    0.04859973, -0.99819437, -0.03529980,
    0.05509891, -0.99818029, -0.02449951,
    0.05850061, -0.99821036, -0.01240013,
    0.05999990, -0.99819838, 0.00000000,
    0.05850061, -0.99821036, 0.01240013,
    0.05509891, -0.99818029, 0.02449951,
    0.04859973, -0.99819437, 0.03529980,
    0.04019983, -0.99819579, 0.04459981,
    0.03000005, -0.99820157, 0.05190008,
    0.01859991, -0.99819520, 0.05709973,
    0.00630005, -0.99820839, 0.05950050,
    -0.00630005, -0.99820839, 0.05950050,
    -0.01859991, -0.99819520, 0.05709973,
    -0.03000005, -0.99820157, 0.05190008,
    -0.04019983, -0.99819579, 0.04459981,
    -0.04859973, -0.99819437, 0.03529980,
    -0.05509891, -0.99818029, 0.02449951,
    -0.70658709, 0.55228986, -0.44239190,
    -0.75871474, -0.63751239, 0.13390261,
    -0.51190041, -0.58540045, -0.62870048,
    0.74108439, 0.55598825, -0.37639207,
    0.73287514, -0.64877799, 0.20489305,
    0.56917839, -0.57717811, -0.58557783,
    0.56911082, -0.57721097, -0.58561111,
    0.43801611, 0.60012202, -0.66932462,
    0.69189416, 0.55969529, 0.45609610,
    -0.04420099, 0.69171550, 0.72081616,
    -0.69443816, 0.56863123, 0.44092423,
    -0.69448996, 0.56859172, 0.44089359,
    -0.46559584, 0.59349471, -0.65649413,
    0.68070211, 0.69340219, 0.23630074,
    0.76038811, 0.60169057, -0.24449617,
    0.02209999, 0.59299959, -0.80489942,
    0.00059998, 0.54708488, 0.83707692,
    -0.79670578, 0.60370439, 0.02830021,
    0.36268926, 0.88697381, 0.28589154,
    0.00799966, -0.54087671, -0.84106384,
    -0.65239583, -0.56529634, 0.50479673,
    -0.65249009, -0.56519140, 0.50479240,
    -0.61440034, 0.64430030, -0.45540021,
    -0.65239583, 0.56529634, 0.50479673,
    -0.65243268, 0.56522829, 0.50482530,
    -0.65249009, 0.56519140, 0.50479240,
    0.64753069, 0.56592687, 0.51032419,
    0.64753069, 0.56592687, 0.51032419,
    0.64749408, 0.56599481, 0.51029529,
    0.00800033, 0.54092224, -0.84103456,
    0.00799966, 0.54087671, -0.84106384,
    0.68792913, 0.68932919, 0.22710962,
    0.75717229, 0.60657782, -0.24239114,
    0.03489951, 0.59049177, -0.80628872,
    0.00050002, 0.54731665, 0.83692547,
    -0.76251645, 0.64361389, 0.06580142,
    -0.76255831, 0.64356480, 0.06579641,
    -0.78276960, 0.34128674, -0.52037977,
    0.23300228, 0.95420935, 0.18760184,
    0.23290769, 0.95423159, 0.18760619,
    0.02060134, -0.54133510, -0.84055452,
    -0.66451373, -0.56471166, 0.48941010,
    -0.66451373, 0.56471166, 0.48941010,
    -0.66451373, 0.56471166, 0.48941010,
    0.64242089, 0.56521833, 0.51751680,
    0.64242089, 0.56521833, 0.51751680,
    0.64238455, 0.56528642, 0.51748754,
    0.02060134, 0.54133510, -0.84055452,
    0.02049965, 0.54129070, -0.84058559,
  ]),
  materialIndex: 0,
};

const LAW_MESH_1: RuneMesh = {
  name: "Law_Rune_primitive1",
  positions: new Float32Array([
    0.30019999, 0.34580007, 0.62919998,
    0.02510000, 0.34580001, 0.15369996,
    0.11340000, 0.34579998, -0.34570003,
    -0.35530001, 0.34580004, 0.58170003,
    -0.06660000, 0.34580001, 0.11969997,
    -0.07340000, 0.34579998, -0.38980004,
    -0.29420000, 0.34579998, -0.38640004,
    -0.35530001, 0.34579998, -0.53250003,
    0.03530000, 0.34579998, -0.53590000,
    0.39539999, 0.34579998, -0.48830003,
    0.34779999, 0.34579998, -0.33890003,
    -0.57609999, 0.34580001, -0.09430003,
    -0.63389999, 0.34580001, 0.11289997,
    -0.44369999, 0.34580004, 0.26579997,
    -0.39269999, 0.34579998, -0.53250003,
    -0.19570000, 0.34580001, -0.06370003,
    -0.30779999, 0.34580001, -0.07050003,
    -0.39269999, 0.34579998, -0.42380002,
    -0.48440000, 0.34580001, -0.07050003,
    -0.26359999, 0.34580001, 0.13669997,
    0.26289999, 0.34580001, -0.06710003,
    0.20850000, 0.34580001, 0.15709998,
    0.38519999, 0.34580004, 0.30989996,
    0.43950000, 0.34579998, -0.48490003,
    0.62970001, 0.34580001, -0.03650003,
    0.62970001, 0.34580001, -0.03650003,
    0.58219999, 0.34580001, 0.16729997,
    0.58219999, 0.34580001, 0.16729997,
    0.52440000, 0.34580001, -0.01620003,
    0.44290000, 0.34579998, -0.35920003,
    0.44290000, 0.34579998, -0.35920003,
    0.34439999, 0.34580001, -0.01960003,
  ]),
  indices: new Uint16Array([
    1, 0, 3, 1, 3, 4, 9, 10, 2, 2, 1, 4,
    5, 6, 7, 2, 4, 5, 8, 9, 2, 5, 7, 8,
    5, 8, 2, 12, 11, 17, 18, 16, 15, 12, 17, 18,
    19, 13, 12, 18, 15, 19, 18, 19, 12, 15, 16, 17,
    17, 11, 14, 17, 14, 15, 25, 27, 28, 25, 28, 29,
    31, 28, 26, 26, 22, 21, 21, 20, 23, 23, 24, 30,
    31, 26, 21, 23, 30, 31, 31, 21, 23,
  ]),
  normals: new Float32Array([
    -0.70658709, 0.55228986, -0.44239190,
    -0.75866637, -0.63757173, 0.13389407,
    -0.51193035, -0.58533473, -0.62873728,
    0.74108439, 0.55598825, -0.37639207,
    0.73287514, -0.64877799, 0.20489305,
    0.56911082, -0.57721097, -0.58561111,
    0.43801611, 0.60012202, -0.66932462,
    0.69189416, 0.55969529, 0.45609610,
    -0.04420099, 0.69171550, 0.72081616,
    -0.69443816, 0.56863123, 0.44092423,
    -0.46559584, 0.59349471, -0.65649413,
    0.68070211, 0.69340219, 0.23630074,
    0.76038811, 0.60169057, -0.24449617,
    0.02209999, 0.59299959, -0.80489942,
    0.00060003, 0.54713070, 0.83704697,
    -0.79670578, 0.60370439, 0.02830021,
    0.36268926, 0.88697381, 0.28589154,
    0.00800033, -0.54092224, -0.84103456,
    -0.65243268, -0.56522829, 0.50482530,
    -0.61440034, 0.64430030, -0.45540021,
    0.68792913, 0.68932919, 0.22710962,
    0.75717229, 0.60657782, -0.24239114,
    0.03489951, 0.59049177, -0.80628872,
    0.00050002, 0.54731665, 0.83692547,
    -0.76255330, 0.64356055, 0.06589596,
    -0.76255831, 0.64356480, 0.06579641,
    -0.78276960, 0.34128674, -0.52037977,
    -0.78281034, 0.34130452, -0.52030683,
    0.23290769, 0.95423159, 0.18760619,
    0.02059961, -0.54128962, -0.84058385,
    0.02049965, -0.54129070, -0.84058559,
    -0.66450870, -0.56480741, 0.48930642,
  ]),
  materialIndex: 1,
};

export const LAW_MESHES: RuneMesh[] = [
  LAW_MESH_0,
  LAW_MESH_1,
];
